<template>
  <div class="contact-page">
    <h3 class="page-title">Our Service is 24 Hour</h3>
    <div class="theme-card welcome-card">
      <img
        src="https://aubet77mmk.com/mobile/images/contact/base.png"
        alt=""
      />
      <div>
        <h2>Welcome To PG-BOSS Live Support!</h2>
        <span>24 hours online for you.</span>
      </div>
    </div>

    <div class="contact-grid">
      <div class="theme-card contact-item">
        <img src="https://yoeyar.vip/build/assets/img/theme/telegram.png" alt="" />
        <h3>Telegram Official Chat Box</h3>
      </div>
      <div class="theme-card contact-item">
        <img src="https://yoeyar.vip/build/assets/img/theme/telegram.png" alt="" />
        <h3>Telegram Group</h3>
      </div>
      <div class="theme-card contact-item">
        <img src="https://yoeyar.vip/build/assets/img/theme/facebook.png" alt="" />
        <h3>Facebook Page</h3>
      </div>
      <div class="theme-card contact-item">
        <img src="https://yoeyar.vip/build/assets/img/theme/viber.png" alt="" />
        <h3>Viber Official</h3>
      </div>
    </div>

    <div class="theme-card about-card">
      <h3>About Us</h3>
      <span>
        Lorem ipsum dolor, sit amet consectetur adipisicing elit. Cupiditate
        ratione ea deleniti, natus quae veritatis sit laudantium dignissimos nam
        aut. Ea itaque laborum quod excepturi minima nostrum harum hic aliquid!
      </span>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      websiteInfo: [],
    };
  },
  methods: {
    ...mapActions(["fetchUser"]),
    async fetchWebsiteData() {
      try {
        const res = await axios.get("/website-infos");
        this.websiteInfo = res.data.data[0];
      } catch (error) {
        console.log(error);
      }
    },
  },
  async mounted() {
    const authUser = await this.fetchUser();
    if (!authUser) {
      this.$router.push("/auth/login");
    }
    this.fetchWebsiteData();
  },
};
</script>
<style scoped>
.contact-page {
  min-height: 100vh;
  padding: 16px 14px 8rem;
}

.page-title {
  text-align: center;
  margin-bottom: 16px;
  color: #f0e6c8;
  text-transform: uppercase;
}

.theme-card {
  background: #1c1c1c;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 14px;
}

.welcome-card {
  display: flex;
  align-items: center;
  padding: 14px;
  margin-bottom: 12px;
}

.welcome-card img {
  width: 50px;
  margin-right: 12px;
}

.contact-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

.contact-item {
  padding: 18px 10px;
  text-align: center;
}

.contact-item img {
  width: 35px;
  height: 35px;
}

.contact-item h3 {
  margin-top: 10px;
  font-size: 0.9rem;
}

.about-card {
  margin-top: 12px;
  padding: 16px;
}

.about-card span {
  color: #c9c3b8;
}
</style>
